export class NumericalRangeFactory {
    static create(range: INumericalRange): IContentAPINumericalRange {
        return new NumericalRange(range).serialize();
    }
}

export class NumericalRange {
    protected _min: string | number;
    protected _max: string | number;
    protected _increment?: string | number;

    constructor(range: INumericalRange) {
        this._min = range.min;
        this._max = range.max;
        this._increment = range.increment;
    }

    get min(): string | number {
        return this._min;
    }

    get max(): string | number {
        return this._max;
    }

    get increment(): string | number | undefined {
        return this._increment;
    }

    serialize(): IContentAPINumericalRange {
        const range: IContentAPINumericalRange = {
            min: this._min,
            max: this._max
        };

        if (this._increment !== undefined) {
            range.increment = this._increment;
        }

        return range;
    }
}

export interface IContentAPINumericalRange {
    min: string | number;
    max: string | number;
    increment?: string | number;
}